// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"_1mz9vwD8vyuE94SJ6jU-tX"};